import { render, staticRenderFns } from "./showCouponBatch.vue?vue&type=template&id=07d033a4&"
import script from "./showCouponBatch.vue?vue&type=script&lang=js&"
export * from "./showCouponBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d033a4')) {
      api.createRecord('07d033a4', component.options)
    } else {
      api.reload('07d033a4', component.options)
    }
    module.hot.accept("./showCouponBatch.vue?vue&type=template&id=07d033a4&", function () {
      api.rerender('07d033a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/components/showCouponBatch.vue"
export default component.exports